import React, { useEffect, useState } from 'react'
import { Container, Form, Table, Tabs, Tab } from 'react-bootstrap'
import { ORDERS_COLLECTION } from '../../firebase'
import { useHistory } from 'react-router'
import { Link } from 'react-router-dom'
import moment from 'moment'

const PreviewOrder = () => {

    const history = useHistory()

    const [items, setItems] = useState([])

    const [search, setSearch] = useState('')

    const filteredItems = items.filter((item) => {

        let canReturnItem = false;

        const searchLowerCase = search.toLowerCase()

        if (item?._id && item._id.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }
        if (item?.contact && item.contact.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }
        if (item?.game && item.game.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }
        if (item?.method_of_payment && item.method_of_payment.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }
        if (item?.name && item.name.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }
        if (item?.price && item.price.toLowerCase().includes(searchLowerCase)) {
            canReturnItem = true
        }

        return canReturnItem
    })

    useEffect(() => {

        const getItems = async () => {
            const snapshot = await ORDERS_COLLECTION.get()
            const items = []
            snapshot.forEach(doc => {
                items.push(doc.data())
            })
            setItems(items)
        }

        getItems()

    }, [])

    return (
        <>
            <Container>
                <Tabs defaultActiveKey="preview-order" className="mb-3" transition={false}>
                    <Tab eventKey="preview-order" title="Pregled narudžbi">
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Pretraga</Form.Label>
                                <Form.Control type="search" placeholder="Unesite pojam za pretragu..." onChange={(e) => setSearch(e.target.value)} />
                                <Form.Text className="text-muted">
                                    Pretražite prema polju Kontakt, Igra, Način plaćanja, Ime i Cijena.
                                </Form.Text>
                            </Form.Group>
                        </Form>
                        <Table striped bordered hover responsive>
                            <thead>
                                <tr>
                                    <th>Uredi / obriši</th>
                                    <th>ID</th>
                                    <th>Kontakt</th>
                                    <th>Datum</th>
                                    <th>Izvršeno</th>
                                    <th>Igra</th>
                                    <th>Način plaćanja</th>
                                    <th>Ime</th>
                                    <th>Cijena</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredItems.map((item) => (
                                    <tr key={item._id}>
                                        <td>
                                            <div>
                                                <Link to={`/edit-order/${item._id}`}>
                                                    Uredi
                                                </Link>
                                                <br />
                                                <Link to={`/delete-order/${item._id}`}>
                                                    Obriši
                                                </Link>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item._id}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.contact}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.date ? moment(item.date.toDate()).format('DD/MM/YYYY') : '-'}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.done === true ? 'Da' : 'Ne'}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.game}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.method_of_payment}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.name}
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                {item.price}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Tab>
                    <Tab eventKey="add-order" title={<div onClick={() => history.push('/add-order')}>Dodaj</div>} />
                    <Tab eventKey="edit-order" title='Uredi' disabled />
                    <Tab eventKey="delete-order" title='Obriši' disabled />
                </Tabs>
            </Container>
        </>
    )
}

export default PreviewOrder
